import React, { useEffect, useRef, useState } from "react";
import { Target, Loader2 } from "lucide-react";
import { api } from "@/lib/apiClient";

// Player-level scorer model — likeliest first / anytime scorers with evidence; honest about sample sizes.
export const ScorersCard = ({ teamId, oppId, venue }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const seq = useRef(0);
  const [tick, setTick] = useState(0);
  useEffect(() => { const h = () => setTick((t) => t + 1); window.addEventListener("octon:team-news-changed", h); return () => window.removeEventListener("octon:team-news-changed", h); }, []);
  useEffect(() => {
    if (!teamId || !oppId) return;
    const my = ++seq.current;
    setLoading(true); setData(null);
    api.get(`/predict/scorers?team_id=${teamId}&opponent_id=${oppId}&venue=${venue}`, { timeout: 60000 })
      .then((r) => my === seq.current && setData(r.data)).catch(() => {}).finally(() => my === seq.current && setLoading(false));
  }, [teamId, oppId, venue, tick]);
  const top = data?.first_scorer_top || [];
  return (
    <div className="card-tac mt-4 p-6" data-testid="scorers-card" data-octon-section="scorers first goalscorer anytime danger men player level" data-octon-label="Likely Scorers" data-octon-state={loading ? "loading" : data ? "ready" : "idle"}>
      <div className="flex items-center gap-2">
        <Target size={16} className="txt-cyan" />
        <span className="font-tac text-[10px] tracking-widest text-white/60">LIKELY SCORERS · PLAYER-LEVEL POISSON</span>
        {loading && <Loader2 size={13} className="animate-spin text-white/40" />}
      </div>
      {data && (
        <>
          <p className="mt-1 text-[11px] text-white/45">Team xG {data.team_xg} – {data.opponent_xg} split across the probable XI by goal-share · P(0-0) {data.p_no_goal_0_0_pct}% · likelihoods, not certainties</p>
          <div className="mt-3 grid gap-2 sm:grid-cols-2">
            {top.slice(0, 6).map((r, i) => (
              <div key={r.player + i} className="flex items-center justify-between rounded-xl border border-white/8 bg-black/30 px-3 py-2" data-testid={`scorer-${i}`}>
                <div>
                  <p className="text-sm font-semibold text-white/90">{r.player} <span className="text-[10px] text-white/40">{r.club} · {r.position}</span></p>
                  <p className="text-[10px] text-white/40">{r.evidence}</p>
                </div>
                <div className="text-right">
                  <p className="font-mono text-sm" style={{ color: "#ccff00" }}>{r.first_scorer_pct}% <span className="text-[9px] text-white/40">first</span></p>
                  <p className="font-mono text-[11px] text-white/60">{r.anytime_pct}% anytime</p>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
